export class Conta {
idConta: number;
nome?: string;
}
